import React, { useState } from 'react';
import Valg from '../Models/Valg';
import ValgTillegg from '../Models/ValgMedtillegg';
import { ModalCompontent } from './ModalComponent';
import { ArticleContentComponent } from './ArticleContentComponent';
import { AppState } from '../Store/Types';
import { connect } from 'react-redux';
import { setCollapsed } from '../Store/StegVisning/Actions';
import { StegVisning } from '../Store/StegVisning/Types';
import VeilederStegComponent, { VeilederStegDefaultProps, VeilederStegBaseProps } from './VeilederStegComponent';

type SkolePengerVisningOwnProps = VeilederStegDefaultProps &
    VeilederStegBaseProps & {
        ledetekst: JSX.Element | null;
        onChange: any;
        showSearch?: boolean;
        value?: Valg<string>;

        benevnelseForSkolepenger: any;
        valutaBenevnelse: string;
        valgUkjentInputLedetekst: any;
        valgKnappTekst: any;
        visMerOmSkolePengerLenkeTekst: any;
        lukkSkolepengerPopupAriaTekst: any;
        tittelMerSkolePengerTekst: any;
        brodtekstMerSkolePengerTekst: any;
        locale: string;
        visBiCheckbox: boolean;
        biLabel: string | null;
    };

type SkolePengerVisningProps = SkolePengerVisningOwnProps & MapStateToProps & MapDispatchToProps;

function SkolePengerInputSteg(props: SkolePengerVisningProps): JSX.Element {
    const [inputValue, setInputValue] = useState('0');
    const [ingenSkolePenger, setIngenSkolePenger] = useState(false);
    const [visSkolePengerModal, setVisSkolePengerModal] = useState(false);
    const [biStudent, setBiStudent] = useState(false);

    /*function uncheckVetIkkeAvhukingsboks(): void {
        const avhuking: HTMLInputElement = document.getElementById(
            'radio-vetikke-' + props.sporsmalId,
        ) as HTMLInputElement;
        avhuking.checked = false;
    }*/

    function biInputChangeHandler(e: React.ChangeEvent<HTMLInputElement>): void {
        if (e.currentTarget.checked) {
            setBiStudent(true);
        } else {
            setBiStudent(false);
        }
    }

    function vetIkkeInputChangeHandler(e: React.ChangeEvent<HTMLInputElement>): void {
        if (e.currentTarget.checked) {
            setIngenSkolePenger(true);
        } else {
            setIngenSkolePenger(false);
        }
        setInputValue('0');
    }

    function bekreft(e: React.SyntheticEvent<HTMLButtonElement>): void {
        e.preventDefault();

        if (!props.visBiCheckbox) {
            let valg: Valg<string>;

            if (ingenSkolePenger !== null && ingenSkolePenger) {
                valg = { id: 'IngenSkolePenger', displayValue: 'Vet ikke', value: '999999' };
            } else {
                valg = { id: '', displayValue: inputValue, value: removeCommasFromInputValue() }
            }

            props.onChange(valg);
        } else {
            let valg: ValgTillegg<string>;
            if (ingenSkolePenger !== null && ingenSkolePenger) {
                valg = { id: 'IngenSkolePenger', displayValue: 'Vet ikke', value: '999999', tillegg: biStudent };
            } else {
                valg = { id: '', displayValue: inputValue, value: removeCommasFromInputValue(), tillegg: biStudent };
            }

            props.onChange(valg);
        }

        props.stegVisningSetCollapsed({ id: props.sporsmalId, isCollapsed: true });
    }

    function removeCommasFromInputValue(): string {
        return inputValue.replace(',', '');
    }

    function kronerInputChangeHandler(e: React.SyntheticEvent<HTMLInputElement>): void {
        setIngenSkolePenger(false);

        const verdiUtenSpace: string = e.currentTarget.value.replace(/\s/g, '');

        let verdiKunMedTal: string = verdiUtenSpace.replace(/\D/g, '');

        if (verdiKunMedTal.length > 1 && verdiKunMedTal.startsWith('0')) {
            verdiKunMedTal = verdiKunMedTal.substr(1);
        }

        const formatertVerdi: string = formatNumber(verdiKunMedTal);
        // Overskriv tom streng med '0' siden det ikke er en gyldig verdi
        setInputValue(formatertVerdi || '0');

        //uncheckVetIkkeAvhukingsboks();
    }

    function onMerOmSkolepengerClick(): void {
        setVisSkolePengerModal(true);
    }

    function onRequestCloseMerOmSkolePenger(): void {
        setVisSkolePengerModal(false);
    }

    function onKeyUpInputHandler(e: React.KeyboardEvent<HTMLInputElement>): void {
        //enter
        if (e.key == 'Enter') {
            const valg: Valg<string> = { id: '', displayValue: inputValue, value: removeCommasFromInputValue() };
            props.onChange(valg);
            props.stegVisningSetCollapsed({ id: props.sporsmalId, isCollapsed: true });
        }
    }

    function formatNumber(tall: string): string {
        let tallSomString: string = tall.toString();
        if (props.locale === 'en-US') {
            tallSomString = tallSomString.replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ',');
        } else {
            tallSomString = tallSomString.replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' ');
        }

        return tallSomString;
    }

    function hentCheckboxForBi(): JSX.Element | null {
        if (!props.visBiCheckbox) return null;

        return (
            <div className="c-veileder__inputomrade">
                <div className="c-veileder__checkbox">
                    <input
                        name="radioMedInput"
                        onChange={biInputChangeHandler}
                        id={'radio-bi-' + props.sporsmalId}
                        type="checkbox"
                    />
                    <label htmlFor={'radio-bi-' + props.sporsmalId}>{props.biLabel}</label>
                </div>
            </div>
        );
    }

    return (
        <VeilederStegComponent
            tittel={props.tittel}
            forklaring={
                <div>
                    {props.forklaring}

                    <button
                        type="button"
                        className="c-knapp c-knapp--lenke c-knapp--lenke-aubergine"
                        onClick={onMerOmSkolepengerClick}
                    >
                        {props.visMerOmSkolePengerLenkeTekst}
                    </button>
                    <ModalCompontent
                        isOpen={visSkolePengerModal}
                        onRequestClose={onRequestCloseMerOmSkolePenger}
                        ariaCloseText={props.lukkSkolepengerPopupAriaTekst}
                    >
                        <ArticleContentComponent
                            headerinnhold={props.tittelMerSkolePengerTekst}
                            contentinnhold={props.brodtekstMerSkolePengerTekst}
                        />
                    </ModalCompontent>
                </div>
            }
            canCollapse={props.value != null}
            displayElement={
                <div className="c-veileder__valgt-item">
                    <span className="c-veileder__tekst c-veileder__tekst--valg">{props.value?.displayValue}</span>
                </div>
            }
            inputArea={
                <div className="c-veileder__inputomrade">
                    <div className="c-veileder__inputomrade">
                        <label htmlFor={'input-' + props.sporsmalId} className="c-veileder__undersporsmal">
                            {props.ledetekst}
                        </label>
                        <div className="c-text-input">
                            <input
                                onKeyUp={onKeyUpInputHandler}
                                className="c-text-input__input c-text-input__input--half c-text-input__input--space"
                                onChange={kronerInputChangeHandler}
                                id={'input-' + props.sporsmalId}
                                type="text"
                                value={inputValue}
                            />
                            <span className="c-text-input__input--ekstra-ledetekst">
                                {props.valutaBenevnelse} {props.benevnelseForSkolepenger}
                            </span>
                        </div>
                    </div>
                    <div className="c-veileder__inputomrade">
                        <div className="c-veileder__checkbox">
                            <input
                                name="radioMedInput"
                                onChange={vetIkkeInputChangeHandler}
                                id={'radio-vetikke-' + props.sporsmalId}
                                type="checkbox"
                            />
                            <label htmlFor={'radio-vetikke-' + props.sporsmalId}>
                                {props.valgUkjentInputLedetekst}
                            </label>
                        </div>
                    </div>
                    {hentCheckboxForBi()}
                    <div className="c-veileder__content--cta-area c-veileder__content-custom">
                        <button
                            id="js-bekreft-skolepenger-knapp"
                            onClick={bekreft}
                            className="c-knapp c-knapp--cta c-knapp--secondary"
                        >
                            {props.valgKnappTekst}
                        </button>
                    </div>
                </div>
            }
            sporsmalId={props.sporsmalId}
        />
    );
}

interface MapStateToProps {
    stegState: StegVisning;
}

interface MapDispatchToProps {
    stegVisningSetCollapsed: typeof setCollapsed;
}

export default connect(
    (state: AppState, ownProps: SkolePengerVisningOwnProps): MapStateToProps => {
        const stegState = state.stegVisning[ownProps.sporsmalId]
            ? state.stegVisning[ownProps.sporsmalId]
            : { id: ownProps.sporsmalId, isCollapsed: false };
        return {
            stegState,
        };
    },
    {
        stegVisningSetCollapsed: setCollapsed,
    },
)(SkolePengerInputSteg);
